import { alpha } from '@mui/material/styles';

const colors = {
  background: {
    gray1: '#f5f5f5',
  },
  primary: {
    main: '#3C55E8',
  },
};

export const useStyles = {
  menu: {
    padding: '32px 24px',
  },
  menuItem: {
    backgroundColor: colors.background.gray1,
    borderRadius: '0 12px 12px 0',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-start',
    fontWeight: 'bold',
    fontFamily: 'Montserrat, Arial, sans-serif',
    fontSize: '14px',
    textTransform: 'capitalize',
    border: 'none',
    cursor: 'pointer',
    marginBottom: '4px',
    '&:hover': {
      backgroundColor: colors.background.gray1,
    },
  },
  selected: {
    backgroundColor: alpha(colors.primary.main, 0.05),
    color: colors.primary.main,
    '&:hover': {
      backgroundColor: alpha(colors.primary.main, 0.15),
    },
  },
  spaceUsed: {
    color: colors.primary.main,
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '12px 16px',
  },
  menuEnd: {
    marginTop: 'auto',
    padding: '32px 24px',
  },
  availableText: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: colors.primary.main,
    marginTop: '8px',
  },
  storageLinearProgress: {
    borderRadius: '3px',
  },
};
